export const DocumentConstants = {
    
    ASSIGN_DOC_PATIENT_REQUEST : 'ASSIGN_DOC_PATIENT_REQUEST',
    ASSIGN_DOC_PATIENT_SUCCESS : 'ASSIGN_DOC_PATIENT_SUCCESS',
    ASSIGN_DOC_PATIENT_FAILIURE : 'ASSIGN_DOC_PATIENT_FAILIURE',

    GET_ALL_DOC_REQUEST : 'GET_ALL_DOC_REQUEST',
    GET_ALL_DOC_SUCCESS : 'GET_ALL_DOC_SUCCESS',
    GET_ALL_DOC_FAILIURE : 'GET_ALL_DOC_FAILIURE',

    GET_ACTIVE_DOC_REQUEST : 'GET_ACTIVE_DOC_REQUEST',
    GET_ACTIVE_DOC_SUCCESS : 'GET_ACTIVE_DOC_SUCCESS',
    GET_ACTIVE_DOC_FAILIURE : 'GET_ACTIVE_DOC_FAILIURE',
    
    GET_PENDING_DOC_REQUEST : 'GET_PENDING_DOC_REQUEST',
    GET_PENDING_DOC_SUCCESS : 'GET_PENDING_DOC_SUCCESS',
    GET_PENDING_DOC_FAILIURE : 'GET_PENDING_DOC_FAILIURE',
    
    SUBMIT_DOC_REQUEST : 'SUBMIT_DOC_REQUEST',
    SUBMIT_DOC_SUCCESS : 'SUBMIT_DOC_SUCCESS',
    SUBMIT_DOC_FAILIURE : 'SUBMIT_DOC_FAILIURE',

    CANCEL_DOC_REQUEST : 'CANCEL_DOC_REQUEST',
    CANCEL_DOC_SUCCESS : 'CANCEL_DOC_SUCCESS',
    CANCEL_DOC_FAILIURE : 'CANCEL_DOC_FAILIURE',
    

    GET_DOC_BY_ID_REQUEST : 'GET_DOC_BY_ID_REQUEST',
    GET_DOC_BY_ID_SUCCESS : 'GET_DOC_BY_ID_SUCCESS',
    GET_DOC_BY_ID_FAILIURE : 'GET_DOC_BY_ID_FAILIURE',

    CLEAR_ALL_DOCUMENT_DETAILS : 'CLEAR_ALL_DOCUMENT_DETAILS',

};